// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".terminal-tab{align-items:center;border-right:1px solid #fff;display:flex;float:left;height:40px;justify-content:space-between;padding:0 10px;width:100px}.terminal-tab-active{background-color:hsla(0,0%,100%,.2)}.terminal-tab-add{width:auto}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
